import axiosInstance from ".";

export const fetchAvailableCoupons = () =>
  axiosInstance.get(`/v1/coupons/available`);

export const fetchMyCoupons = () =>
  axiosInstance.get(`/v1/coupons/mine`);

export const claimCoupon = (id) =>
  axiosInstance.post(`/v1/coupons/${id}/claim`);

export const verifyCoupon = (code) =>
  axiosInstance.post(`/v1/coupons/verify`, { code });

export const redeemCoupon = (code) =>
  axiosInstance.post(`/v1/coupons/redeem`, { code });
